export default __webpack_public_path__ + "static/otos-brain-3ddbb2c81670baacc82a169059f62942.png";